module.exports = __webpack_public_path__ + "img/ASL Securities.8c28316f.png";